import React from "react";
import { Outlet } from "react-router-dom";

const ShowingActivity = () => {
  return (
    <div className="nav-content-wrapper bg-[#FAFAFA]">
      <div className="p-4">
        <p className="text-[17px] font-inter-semibold">Showing Activity</p>
      </div>
      <Outlet />
    </div>
  );
};

export default ShowingActivity;
